import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { legalIdFields } from "@/lib/legalIdentity";

export function ClientFormDialog({ open, onOpenChange, editing, form, setField, onSave }) {
  const legalIds = legalIdFields(form.country);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>{editing ? "Modifier" : "Nouveau"} client</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Type</Label>
            <Select value={form.type} onValueChange={v => setField("type", v)}>
              <SelectTrigger data-testid="client-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="client">Client</SelectItem>
                <SelectItem value="prospect">Prospect</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div><Label>Société</Label><Input value={form.company} onChange={e => setField("company", e.target.value)} data-testid="client-company-input" /></div>
          <div><Label>Nom commercial</Label><Input value={form.trade_name} onChange={e => setField("trade_name", e.target.value)} placeholder="Nom court / commercial" data-testid="client-trade-name-input" /></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div><Label>Prénom</Label><Input value={form.first_name} onChange={e => setField("first_name", e.target.value)} data-testid="client-firstname-input" /></div>
            <div><Label>Nom</Label><Input value={form.last_name} onChange={e => setField("last_name", e.target.value)} data-testid="client-lastname-input" /></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={e => setField("email", e.target.value)} data-testid="client-email-input" /></div>
            <div><Label>Téléphone</Label><Input value={form.phone} onChange={e => setField("phone", e.target.value)} data-testid="client-phone-input" /></div>
          </div>
          <div><Label>Adresse</Label><Input value={form.address} onChange={e => setField("address", e.target.value)} /></div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div><Label>Code postal</Label><Input value={form.postal_code} onChange={e => setField("postal_code", e.target.value)} /></div>
            <div><Label>Ville</Label><Input value={form.city} onChange={e => setField("city", e.target.value)} /></div>
            <div><Label>Pays</Label><Input value={form.country} onChange={e => setField("country", e.target.value)} data-testid="client-country-input" /></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {legalIds.map(f => (
              <div key={f.field}>
                <Label>{f.label}</Label>
                <Input
                  value={form[f.field] || ""}
                  onChange={e => setField(f.field, e.target.value)}
                  placeholder={f.placeholder}
                  data-testid={`client-${f.field}-input`}
                />
              </div>
            ))}
            <div>
              <Label>N° TVA intracommunautaire</Label>
              <Input value={form.tva_number || ""} onChange={e => setField("tva_number", e.target.value)} placeholder="FR 12 345678901" data-testid="client-tva-number-input" />
            </div>
          </div>
          <div><Label>Notes</Label><Textarea value={form.notes} onChange={e => setField("notes", e.target.value)} rows={3} /></div>
          <Button onClick={onSave} className="w-full bg-slate-900 hover:bg-slate-800 text-white uppercase text-xs font-bold tracking-wider" data-testid="save-client-btn">Enregistrer</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
